import { render, staticRenderFns } from "./getstarted.vue?vue&type=template&id=071d5434&"
import script from "./getstarted.vue?vue&type=script&lang=js&"
export * from "./getstarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports